import { Button, IconButton } from "@material-ui/core";
import React, { useState } from "react";
import { handleInputChange } from "react-select/src/utils";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import useSWR from "swr";
import { IOmniumType, PopupType } from "../../Models/Entities";
import { fetcher } from "../../Models/Fetcher";
import { popupState, selectedTypesState } from "../../Store/atoms";
import OmniumTypeButton from "./OmniumTypeButton";
import AddIcon from "@material-ui/icons/Add";

import "./styles.css";
import Loading from "../Utilities/Loading";
import Error from "../Error";

interface ITypesDisplayProps {
  url: string;
  type: string;
  locked: boolean;
}

export default ({ url, type, locked }: ITypesDisplayProps) => {
  const setPopup = useSetRecoilState(popupState);
  const [selected, setSelectedTypes] = useRecoilState(selectedTypesState);

  const { data, error } = useSWR(url, fetcher);

  if (!data) {
    return <Loading />;
  }

  if (data.status !== 200) {
    console.log(error);
    return <div>SHALO</div>;
  }

  if (error) {
    return (
      <Error
        code={data.code}
        message={data.data.message}
        button={{ route: "/favorites", text: "Back to my tables" }}
        resetUser={false}
      />
    );
  }

  const types = data.data as IOmniumType[];

  const setSelectedType = (type: IOmniumType, ctrlKey: boolean) => {
    if (!ctrlKey) {
      setSelectedTypes([type]);
    } else {
      setSelectedTypes((selected) => {
        return [type].concat(selected);
      });
    }
  };

  const removeSelectedType = (type: IOmniumType) => {
    setSelectedTypes((selected) => {
      const filtered = selected.filter((item) => item.id !== type.id);
      return filtered;
    });
  };

  const createType = () => {
    setPopup({ type: PopupType.AddNewType, props: { type: type } });
  };

  const active = selected.map((type) => type.id);

  return (
    <div className="types-display">
      {types.map((type) => {
        return (
          <OmniumTypeButton
            type={type}
            unsetSelected={removeSelectedType}
            setSelected={setSelectedType}
            key={type.name}
            active={active.includes(type.id)}
          />
        );
      })}
      {!locked && (
        <Button
          style={{ margin: "0.5rem 1rem " }}
          color="primary"
          variant="contained"
          onClick={createType}
        >
          <AddIcon />
        </Button>
      )}
    </div>
  );
};
